import axios from "axios";

export const getDataTableTransaksiKeluar = async (searchText = null, offset = 0, limit = 0, sortingCol = 0, sortingMode = 'DESC') => {
    if(searchText) {
        return await axios.get(`${window._HOST}akuntan/transaksiKeluar/dataTable?search-text=${searchText}&iffset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    } else {
        return await axios.get(`${window._HOST}akuntan/transaksiKeluar/dataTable?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    }
}

export const getDataTransKeluar = async (searchText = null, offset = 0, limit = 0, sortingCol = 0, sortingMode = 'DESC') => {
    if(searchText) {
        return await axios.get(`${window._HOST}akuntan/transaksiKeluar/transKeluar?search-text=${searchText}&offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true})
    } else {
        return await axios.get(`${window._HOST}akuntan/transaksiKeluar/transKeluar?offset=${offset}&limit=${limit}&sorting-col=${sortingCol}&sorting-mode=${sortingMode}`, {withCredentials: true});
    }
}

export const insertNewTransaksiKeluar = async (formData) => {
    return await axios.post(`${window._HOST}akuntan/transaksiKeluar/`, formData, {withCredentials: true})
}

export const deleteTransaksiKeluar = async (id_transaksi_keluar) => {
    return await axios.delete(`${window._HOST}akuntan/transaksiKeluar/${id_transaksi_keluar}`, {withCredentials: true})
}